import ApplicationComponent from './ApplicationContainer';

export default ApplicationComponent;
